import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <span className="footer-kicker">El Mercadito</span>
          <h3>Demo modular en React + TypeScript</h3>
          <p>
            Inspirada en una tienda real, con estructura lista para crecer hacia catálogo, detalle
            de producto, login, carrito y checkout.
          </p>
        </div>

        <div>
          <h4>Mapa del sitio</h4>
          <a href="#inicio">Inicio</a>
          <a href="#categorias">Categorías</a>
          <a href="#destacados">Destacados</a>
          <a href="#novedades">Novedades</a>
        </div>

        <div>
          <h4>Contacto</h4>
          <p>San José, Costa Rica</p>
          <p>WhatsApp: +506 8888-8888</p>
          <p>Correo: hola@elmercadito.demo</p>
        </div>

        <div>
          <h4>Redes</h4>
          <div className="social-links">
            <span className="social-icon" role="img" aria-label="Instagram">
              <FaInstagram />
            </span>
            <span className="social-icon" role="img" aria-label="Facebook">
              <FaFacebookF />
            </span>
            <span className="social-icon" role="img" aria-label="TikTok">
              <FaTiktok />
            </span>
            <span className="social-icon" role="img" aria-label="WhatsApp">
              <FaWhatsapp />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
